import { Component, Input, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TOAST_NOTIFICATIONS_CONFIG, ToastNotificationsModule, Toast, ToastConfig, Toaster, ToastType } from "ngx-toast-notifications";

@Component({
    template:
    '<div class="toast-container">' +
    '<div class="toast-title">{{toast.caption}}</div>' +
    '<div class="toast-text">{{toast.text}}</div>' +
   /*  '<button (click)="toast.close()">Close</button>' + */
    '</div>',
  })
  export class CustomToastComponent {
    @Input() toast: Toast;
  }